export const afligidos = {
	nombre: "Afligidos",
	dia: "Jueves Santo",
	nombrecompleto:
		"Venerable, Real y Devota Cofradía de Penitencia de Nuestro Padre Jesús de los Afligidos y María Santísima de los Desconsuelos",
	sede: "Parroquia de San Lorenzo Diácono y Mártir",
	pasos: 1,
	distancia: [1350, 1250],
	penitentes: 257,
	cargadores: 56,
	web: "http://www.diariodecadiz.es/semana_santa/Afligidos_0_1229577725.html",

	ida: [
		{ lng: -6.3004124, lat: 36.5315811 },
		{ lng: -6.3003668, lat: 36.5315494 },
		{ lng: -6.3001536, lat: 36.5318608 },
		{ lng: -6.2995461, lat: 36.5315914 },
		{ lng: -6.2983297, lat: 36.5311388 },
		{ lng: -6.2976028, lat: 36.530933 },
		{ lng: -6.2975693, lat: 36.5310073 },
		{ lng: -6.2972783, lat: 36.5308979 },
		{ lng: -6.297059, lat: 36.5308532 },
		{ lng: -6.2967237, lat: 36.5308349 },
		{ lng: -6.2963093, lat: 36.5305897 },
		{ lng: -6.2960592, lat: 36.5303564 },
		{ lng: -6.2957635, lat: 36.5300283 },
		{ lng: -6.2955067, lat: 36.529837 },
		{ lng: -6.2952706, lat: 36.5296754 },
		{ lng: -6.2950547, lat: 36.5296247 },
		{ lng: -6.294879, lat: 36.5296096 },
		{ lng: -6.2946095, lat: 36.5295557 },
		{ lng: -6.2944432, lat: 36.5302303 },
		{ lng: -6.2943426, lat: 36.5305536 },
		{ lng: -6.2939925, lat: 36.5305935 },
		{ lng: -6.2935004, lat: 36.5307411 },
		{ lng: -6.292921, lat: 36.5310741 },
		{ lng: -6.2922196, lat: 36.5302939 },
		{ lng: -6.2928191, lat: 36.5297928 },
		{ lng: -6.2930082, lat: 36.5298155 },
		{ lng: -6.2932751, lat: 36.5297346 },
		{ lng: -6.2937042, lat: 36.5297023 },
		{ lng: -6.2941012, lat: 36.5296721 },
		{ lng: -6.2945317, lat: 36.5296398 },
		{ lng: -6.2946108, lat: 36.5295148 },
		{ lng: -6.2950896, lat: 36.5295913 },
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2957051, lat: 36.5290816 },
		{ lng: -6.2954262, lat: 36.5297605 },
		{ lng: -6.2956864, lat: 36.5299308 },
		{ lng: -6.2952834, lat: 36.5303564 },
		{ lng: -6.2950212, lat: 36.5308327 },
		{ lng: -6.2949219, lat: 36.5308349 },
		{ lng: -6.2949219, lat: 36.5314524 },
		{ lng: -6.2964521, lat: 36.5317821 },
		{ lng: -6.2963985, lat: 36.5318489 },
		{ lng: -6.2967928, lat: 36.5325408 },
		{ lng: -6.2971415, lat: 36.5330569 },
		{ lng: -6.2984638, lat: 36.5343403 },
		{ lng: -6.2998277, lat: 36.5331162 },
		{ lng: -6.2991665, lat: 36.5325666 },
		{ lng: -6.3001817, lat: 36.5318726 },
		{ lng: -6.3003722, lat: 36.5315968 },
		{ lng: -6.300399, lat: 36.5316162 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-29T18:00",
			latlng: [36.53158, -6.30041]
		},
		{
			name: "Nueva",
			hora: "2018-03-29T19:45",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-29T20:45",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-29T21:45",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-29T22:10",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-29T22:20",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Sagasta (izq.)",
			"Hospital de Mujeres (drch)",
			"Libertad",
			"Plaza Topete",
			"Compañía",
			"Santiago",
			"Plaza de Pío XII",
			"Cobos",
			"Cristóbal Colón",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañes", "Palillero"],
		["Novena"],
		["Ancha", "San José (izq.)", "Santa Inés (izq)", "Sagasta (drch)"]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/afligidos.js